import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/** The QR modules of `text` as one SVG path (1 unit = 1 module), with a 4-module quiet zone. */
export function qrPath(text: string): { size: number; d: string } {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  const n = qr.getModuleCount();
  const quiet = 4;
  let d = '';
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (qr.isDark(r, c)) d += `M${c + quiet} ${r + quiet}h1v1h-1z`;
    }
  }
  return { size: n + quiet * 2, d };
}

/**
 * The otpauth:// link as a QR code for the authenticator app's camera. It is drawn in the browser, so the
 * secret never leaves the page. Dark modules on white, because scanners expect that.
 */
export function QrCode({ value, label, size = 176, className }: { value: string; label: string; size?: number; className?: string }) {
  const { size: units, d } = useMemo(() => qrPath(value), [value]);
  return (
    <svg
      className={className}
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${units} ${units}`}
      shapeRendering="crispEdges"
      data-testid="mfa-qr"
    >
      <rect width={units} height={units} fill="#fff" />
      <path d={d} fill="#0B0B0C" />
    </svg>
  );
}
